import { Box, Typography } from '@mui/material'

/**
 * Cabeçalho padrão das telas: título, subtítulo opcional e área de ações
 * à direita (botões, exportação, etc).
 */
const PageHeader = ({ title, subtitle, actions }) => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      alignItems: { xs: 'flex-start', md: 'center' },
      justifyContent: 'space-between',
      gap: 2,
      mb: 3,
    }}
  >
    <Box>
      <Typography variant="h5" fontWeight={600}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions && <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>{actions}</Box>}
  </Box>
)

export default PageHeader
